<template>
    <v-card outlined>
        <v-card plain :loading="fetchingJuegoSorteo" tile elevation="0" color="primary">
            <v-card-text>
                <div v-if="juegoSorteo" class="text-h5 font-weight-bold">
                    {{ juegoSorteo.juego.name }} ~ {{ juegoSorteo.horario }}
                </div>
                <div v-if="breadcrumbItems.length">
                    <!-- TODO -->
                    <v-breadcrumbs :items="breadcrumbItems" divider=">"/>
                </div>
            </v-card-text>
        </v-card>
        <v-divider/>
        <v-card-text>
            <Summary :params="summaryParams" :context="context"/>
        </v-card-text>
        <v-divider/>
        <v-data-table
            :headers="headers"
            :items="list"
            :items-per-page="15"
            :loading="fetching"
        >
            <!-- eslint-disable-next-line -->
            <template v-slot:item.comercio="{ item }">
                <v-btn text small @click="open(item, 'window')">
                    <v-icon class="mr-2" small>mdi mdi-eye-outline</v-icon>
                    {{ item.comercio }} 
                </v-btn>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.venta="{ item }">
                <Venta :reporte="item"/>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.comision="{ item }">
                <Comision :reporte="item"/>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.premio="{ item }">
                <Premio :reporte="item"/>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.total="{ item }">
                <Total :reporte="item"/>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.banqueo="{ item }">
                <Banqueo :reporte="item"/>
            </template>
        </v-data-table>
    </v-card>
    
</template>

<script>
import ReportePorComercioService from '@/services/reporte/ventas/ReportePorComercioService';
import SelectorService from '@/services/front/SelectorService';

import Venta from '@/components/entities/reporte/components/venta.vue';
import Comision from '@/components/entities/reporte/components/comision.vue';
import Premio from '@/components/entities/reporte/components/premio.vue';
import Total from '@/components/entities/reporte/components/total.vue';
import Banqueo from '@/components/entities/reporte/components/banqueo.vue';

import Summary from '@/components/entities/reporte/venta/divisa/summary.vue';

export default {
    components: {
        Venta,
        Comision,
        Premio,
        Total,
        Banqueo,
        Summary
    },
    props: {
        params: {
            defaults: function() {
                return {};
            },
        },
        context: {
            default: 'comercio',
        },
    },
    data: function() { 
        return {
            fetching: false,
            list: [],
            summaryParams: {},

            fetchingJuegoSorteo: false,
            juegoSorteo: null,

            fetchingMaster: false,
            master: null,

            fetchingComercializadora: false,
            comercializadora: null,
            
            fetchingGrupo: false,
            grupo: null,
        };
    },
    computed: {
        headers: function () {
            return [
                ... this.context == 'sistema' ? [{ text: 'Sistema', align: 'start', value: 'comercio' }] : [{ text: 'Comercio', align: 'start', value: 'comercio' }],
                { text: 'Ventas', value: 'venta' },
                { text: 'Comisión', value: 'comision' },
                { text: 'Premio', value: 'premio' },
                { text: 'Total', value: 'total'},
                { text: 'Banqueo',align: 'center', value: 'banqueo' },
            ];
        },
        breadcrumbItems: function () {
            const array = [];

            if (this.master) {
                array.push({
                    text: `Master: ${this.master.name}`
                });
            }

            if (this.comercializadora) {
                array.push({
                    text: `Comercializadora: ${this.comercializadora.name}`
                });
            }

            if (this.grupo) {
                array.push({
                    text: `Grupo: ${this.grupo.name}`
                });
            }

            return array;
        },
        divisa: function () {
            return this.$store.getters['persist/divisa/selected'];
        }
    },
    mounted: function () {
        this.init();
    },
    methods: {
        init: function () {
            this.fetch();
            this.summaryParams = this.params;
            this.fetchJuegoSorteo();
        },
        fetch: async function () {
            this.fetching = true;
            this.list = [];

            const params = { ... this.params, divisa_id: this.divisa.id };

            if (this.context == 'sistema') {
                params['group_by'] = 'sistema';
                params['comercio_type'] = 'sistema';
            }

            try {
                const {
                    reportList
                } = await ReportePorComercioService.getConsolidado(params);

                this.list = reportList;
            } catch (error) {
                console.log(error);
            }

            this.fetching = false;
        },
        fetchJuegoSorteo: async function () {
            this.fetchJuegoSorteo = true;
            this.juegoSorteo = null;

            try {
                const { juegoSorteo } = await SelectorService.getJuegoSorteoBy({
                    id: this.$route.query.juego_sorteo_id
                });
                this.juegoSorteo = juegoSorteo;
            } catch (error) {
                console.log(error);
            }

            this.fetchJuegoSorteo = false;
        },
        open: function (reporte, context = 'tab') {
            const query = {
                ... this.params,
            };
            query[`${reporte.comercio_type}_id`] = reporte.comercio_id;
            const route = this.$router.resolve({
                name: ({
                    'comercio': 'reporte.general',
                    'sistema': 'operadora.sistema.reporte.general',
                })[this.context],
                query: query,
            });
            if (context == 'tab') return window.open(new URL(route.href, window.location.origin), '_blank').focus();
            if (context == 'window') return window.open(new URL(route.href, window.location.origin), '_blank', 'titlebar=no, status=no, menubar=no, height=600 width=1280');
        }
    },
    watch: {
        params: function () {
            this.init();
        },
        'fetching': function (fetching) {
            this.$emit('update:loading', fetching);
        }
    },
}
</script>
<style>

</style>